export default "__VITE_ASSET__12c41056__"